import React, { ReactElement } from 'react';
import Checkbox from 'atomic/form/checkbox';
import { useDispatch } from '@ecommerce/nest-ssr/common';
import { FiltersActions } from 'modules/producers/reducers/producer-url-params.reducer';
import { useProducerUrlType } from 'modules/producers/hooks/use-producer-url';
import { SeoLinkRelEnum } from 'modules/seo-module/interfaces/seo-link-rel.enum';
import { useCategoryUrlType } from 'modules/categories/interfaces/use-category-url.type';

import './filter-entry.scss';

const FilterEntry: React.FC<{
    id: string;
    name: string;
    position: number;
    description: string;
    count: number;
    checked: boolean;
    rel?: string;
    getUrl: useCategoryUrlType | useProducerUrlType;
    filtersActions: typeof FiltersActions;
    limitReached?: boolean;
}> = ({ name, id, count, position, checked, rel, getUrl, filtersActions, limitReached }): ReactElement | null => {
    const dispatch = useDispatch();
    const totalCount = count >= 10000 ? `${count}+` : count;
    const disabled = Boolean(limitReached) && !checked;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        if (event.target.checked) {
            dispatch({ type: filtersActions.SET_FILTER, id });
        } else {
            dispatch({ type: filtersActions.UNSET_FILTER, id });
        }
    };

    return (
        <div className="filter-item">
            <Checkbox
                id={id}
                name={id}
                value={position}
                checked={checked}
                disabled={disabled}
                onChange={handleChange}
            />
            {disabled
                ? (
                    <span className="filter-item__label--disabled" data-cy="filter-link">
                        {name} ({totalCount})
                    </span>
                )
                : (
                    <a
                        href={getUrl({ addFilters: [id], page: 1, query: {} })}
                        rel={checked ? SeoLinkRelEnum.NOFOLLOW : rel}
                        data-cy="filter-link"
                    >
                        {name} ({totalCount})
                    </a>
                )}
        </div>
    );
};

export default FilterEntry;
